<template>
    <div class='bg-light'>
        <div style="width:75%;" v-if="device">
            <apexchart type=heatmap height=350 :options="chartOptions" :series="series"/>
        </div>
    </div>
</template>

<script>
    import {bus} from '../event-bus'
    import {HTTP} from "../http-constants"
    import VueApexCharts from 'vue-apexcharts'
    let moment = require('moment');
    
    export default {
        components: {
            apexchart: VueApexCharts,
        },
        data: function () {
            return {
                device: null,
                values: [],
                series: [],
                chartOptions: {
                    dataLabels: {enabled: false},
                    plotOptions: {
                        heatmap: {
                            shadeIntensity: 0.5,
                            colorScale: {
                                ranges: [
                                    {
                                        from: -1,
                                        to: 5,
                                        name: 'idle',
                                        color: '#00A100'
                                    },
                                    {
                                        from: 90,
                                        to: 110,
                                        name: 'active',
                                        color: '#128FD9'
                                    }],
                            },
                        },
                    },
                    title: {
                        text: "Activity state"
                    },
                    chart: {
                        toolbar: {
                            show: false
                        },
                        animations: {
                            enabled: false,
                        }
                    },
                    xaxis: {
                        type: 'category',
                        title: {text: 'day'},
                        labels: {
                            show: true,
                        }
                    },
                }
            }
        },
        methods: {
            display() {
                console.log('display activity');

                var now = new Date();
                let nb_days = new Date(now.getFullYear(), now.getMonth(), 0).getDate();
                let _values = this.values;

                this.chartOptions.title = {text: "Activity state for " + this.current_month()};

                var _series = new Array(24);
                for (var i = 0; i < _series.length; i++) {
                    const active_hour_list = _values.filter(elem => elem.date.getHours() == i);
                    var _data = new Array(nb_days);
                    for (var j = 0; j < _data.length; j++) {
                        _data[j] = {x: '' + (j + 1), y: 1};
                    }
                    for (var k = 0; k < active_hour_list.length; k++) {
                        const day = active_hour_list[k].date.getDate();
                        _data[day - 1] = {x: '' + day, y: active_hour_list[k].active * 100};
                    }
                    _series[i] = {name: '' + i + '', 'data': _data};
                }
                this.series = _series;
                console.log('series updated');
            },
            current_month() {
                const lang = window.navigator.language;
                return moment().locale(lang).format('MMMM')
            },
            load() {
                var self = this;
                HTTP.get('/hub/devices/' + this.device.id + '/activities/',)
                    .then(function (re) {
                        self.values = [];
                        for (var i = 0; i < re.data.length; i++) {
                            var elem = re.data[i];
                            self.values.push({
                                'date': new Date(elem.datetime),
                                'active': elem.active
                            });
                        }
                        self.display();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
        },
        created: function () {
            bus.$on('tracker_panel', elem => {
                var action = elem.action;
                if (action == 'activity') {
                    this.device = elem.tracker;
                    this.load()
                } else {
                    this.device = null;
                }
            });
        }
    }
</script>